import { motion } from "framer-motion";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { User } from "lucide-react";

const STEP_ANIMATION = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
};

export const StepContact = ({ formData, updateFormData }) => (
  <motion.div key="step5" {...STEP_ANIMATION} className="space-y-6">
    <div className="text-center mb-8">
      <div className="w-16 h-16 bg-[#FF5A1F]/10 mx-auto flex items-center justify-center mb-4">
        <User className="w-8 h-8 text-[#FF5A1F]" />
      </div>
      <h2 className="text-2xl font-['Outfit'] font-bold text-[#0F172A]">Your Details</h2>
      <p className="text-slate-600 mt-2">How can we contact you?</p>
    </div>

    <div className="space-y-4">
      <div>
        <Label className="label-text">Full Name *</Label>
        <Input
          placeholder="John Smith"
          value={formData.name}
          onChange={(e) => updateFormData("name", e.target.value)}
          className="input-field"
          data-testid="name-input"
        />
      </div>

      <div>
        <Label className="label-text">Email Address *</Label>
        <Input
          type="email"
          placeholder="john@example.com"
          value={formData.email}
          onChange={(e) => updateFormData("email", e.target.value)}
          className="input-field"
          data-testid="email-input"
        />
      </div>

      <div>
        <Label className="label-text">Phone Number *</Label>
        <Input
          type="tel"
          placeholder="e.g. 07346 209593"
          value={formData.phone}
          onChange={(e) => updateFormData("phone", e.target.value)}
          className="input-field"
          data-testid="phone-input"
        />
      </div>
    </div>
  </motion.div>
);
